import { combineReducers } from "redux";
import LoginReducer from "./LoginReducer";
import UserReducer from "./UserReducer";
import LayoutReducer from "./LayoutReducer";
import ScrumBoardReducer from "./ScrumBoardReducer";
import NotificationReducer from "./NotificationReducer";
import EcommerceReducer from "./EcommerceReducer";
import LSSReducer from "./LSSReducer";
import growthReducer from "./GrowthOpportunityReducer";
import applyReducer from "./ApplyReducer";
import RaftReducer from "./RaftReducer";
import EducationalReimbursementReducer from "./EducationalReimbursementReducer";
import CommonReducer from "./CommonReducer";
import CampaignReducer from "./CampaignReducer";
import BenefitReducer from "./BenefitsReducer";
import BenefitsDiscountReducer from "./BenefitsDiscountReducer";
import BenefitsCategoryReducer from "./BenefitsCategoryReducer";
import BenefitsLinksReducer from "./BenefitsLinksReducer";
import OrderReducer from "./OrderReducer";
import LocationReducer from "./LocationReducer";
import BuildingReducer from "./BuildingReducer";
import MenuItemReducer from "./MenuItemReducer";
import Newsletter from "./NewsletterReducer";
import BirthdayReducer from "./BirthdayReducer";
import GoldenReferresReducer from "./GoldenReferresReducer";
import VideoReducer from "./VideoReducer";
import KudosReducer from "./KudosReducer";
import CalendarReducer from "./CalendarReducer";
import BannersReducer from "./BannersReducer";
import ExtracurricularCoursesAdminUserReducer from "./ExtracurricularCoursesAdminUserReducer";
import ExtracurricularCoursesAdminCouseReducer from "./ExtracurricularCoursesAdminCourseReducer";
import ExtracurricularCoursesAdminLocationsReducer from "./ExtracurricularCoursesAdminLocationsReducer";
import ExtracurricularCoursesAdminRoomsReducer from "./ExtracurricularCoursesAdminRoomsReducer";
import ExtracurricularCoursesAdminCouseScheduleReducer from "./ExtracurricularCoursesAdminCouseScheduleReducer";
import ExtracurricularCoursesInstructorReducer from "./ExtracurricularCoursesInstructorReducer";
import ExtracurricularCoursesECoursesReducer from "./ExtracurricularCoursesECoursesReducer";
import ExtracurricularCoursesAdminImageReducer from "./ExtracurricularCoursesAdminImageReducer";
import ExtracurricularCoursesAdminLOBReducer from "./ExtracurricularCoursesAdminLOBReducer";
import ConfigurationMessagesReducer from "./ConfigurationMessagesReducer";
import ConfigurationReducer from "./ConfigurationReducer";
import ModulesReducer from "./ModulesReducer";
import MyLocationReducer from "./MyLocationReducer";
import MyLocationUsersReducer from "./MyLocationUsersReducer";
import MedicalAppointmentReducer from "./MedicalAppointmentReducer";
import ScheduleChangeReducer from "./ScheduleChangeReducer";
import CertificateReducer from "./CertificateReducer";
import PersonalDaysReducer from "./PersonalDaysReducer";
import PayrollReducer from "./PayrollReducer";
import CafeteriaReducer from "./CafeteriaReducer";
import DomainsReducer from "./DomainReducers";
const RootReducer = combineReducers({
  domain: DomainsReducer,
  login: LoginReducer,
  user: UserReducer,
  layout: LayoutReducer,
  scrumboard: ScrumBoardReducer,
  notification: NotificationReducer,
  ecommerce: EcommerceReducer,
  lss: LSSReducer,
  newsletters: Newsletter,
  raft: RaftReducer,
  reimbursement: EducationalReimbursementReducer,
  common: CommonReducer,
  campaign: CampaignReducer,
  benefit: BenefitReducer,
  discount: BenefitsDiscountReducer,
  category: BenefitsCategoryReducer,
  links: BenefitsLinksReducer,
  order: OrderReducer,
  locations: LocationReducer,
  menuitems: MenuItemReducer,
  video: VideoReducer,
  kudos: KudosReducer,
  calendar: CalendarReducer,
  banners: BannersReducer,
  personaldays: PersonalDaysReducer,
  payroll: PayrollReducer,
  cafeteria: CafeteriaReducer,
  birthdays: BirthdayReducer,
  modules: ModulesReducer,
  goldenreferres: GoldenReferresReducer,
  building: BuildingReducer,
  ECUsersAdmin: ExtracurricularCoursesAdminUserReducer,
  ECCursersAdmin: ExtracurricularCoursesAdminCouseReducer,
  ECLocationsAdmin: ExtracurricularCoursesAdminLocationsReducer,
  ECRoomsAdmin: ExtracurricularCoursesAdminRoomsReducer,
  ECCouseScheduleAdmin: ExtracurricularCoursesAdminCouseScheduleReducer,
  ECInstructor: ExtracurricularCoursesInstructorReducer,
  ECourses: ExtracurricularCoursesECoursesReducer,
  ECImageAdmin: ExtracurricularCoursesAdminImageReducer,
  ECLOB: ExtracurricularCoursesAdminLOBReducer,
  ConfigMes: ConfigurationMessagesReducer,
  Config: ConfigurationReducer,
  MyLocation: MyLocationReducer,
  MyLocationUser: MyLocationUsersReducer,
  MedicalAppointment: MedicalAppointmentReducer,
  ScheduleChange: ScheduleChangeReducer,
  Certificate: CertificateReducer,
  growthReducer,
  applyReducer,
});

export default RootReducer;
